import { useEffect, useState } from 'react';
import { customerStorage } from '../services/customerStorage';
import useWidgetContext from './useWidgetContext';
import { usePlatformConfig } from './usePlatformConfig';
export const usePersistedCurrencyPreference = () => {
    const { configuration: { dimensions }, } = useWidgetContext();
    const storageCurrency = customerStorage.getCustomerData(dimensions)?.selectedCurrency ?? null;
    const { platformConfig: { priceDisplay }, } = usePlatformConfig();
    const { primary, secondary } = priceDisplay;
    const defaultCurrency = storageCurrency === secondary?.currency;
    const [isSecondaryCurrencyDisplay, setIsSecondaryCurrencyDisplay] = useState(defaultCurrency);
    useEffect(() => {
        const storageInfo = customerStorage.getCustomerData(dimensions);
        storageInfo.selectedCurrency = isSecondaryCurrencyDisplay
            ? secondary?.currency
            : primary?.currency;
        customerStorage.setCustomerData(storageInfo, dimensions);
    }, [
        dimensions,
        isSecondaryCurrencyDisplay,
        primary?.currency,
        secondary?.currency,
    ]);
    const selectedCurrency = isSecondaryCurrencyDisplay
        ? secondary?.currency
        : primary.currency;
    return {
        isSecondaryCurrencyDisplay,
        setIsSecondaryCurrencyDisplay,
        selectedCurrency,
    };
};
//# sourceMappingURL=usePersistedCurrencyPreference.js.map